/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SetDigitalCertificateResponse = {
  type: 'Response',
} as const;
